import React from "react"
import { AppRoutes } from "../../consts/appRoutes.consts"
import GeneralReport from "../../views/generalReport/GeneralReport.view"
import IndividualReport from "../../views/individualReport/IndividualReport.view"
import Clients from "../../views/clients/Clients.view"
import Home from "../../views/home/Home.view"
import ChangeLog from "../../views/changeLog/ChangeLog.view"
import TaskChangeLog from "../../views/taskChangelog/TaskChangeLog.view"
import Dashboard from "../../views/dashboard/Dashboard.view"
import OccupationReport from "../../views/occupationReport/OccupationReport.view"
import ClientBudget from "../../views/clientBudget/ClientBudget.view"
import PendingTasks from "../../views/pendingTasks/PendingTasks.view"
import Client from "../../views/clients/Client.view"
import ProjectForm from "../../views/clients/ProjectForm.view"
import TeamMembers from "../../views/teamMembers/teamMembers.view"
import TeamMemberCreateForm from "../../views/teamMembers/teamMemberCreateForm.view"
import TeamMemberEditForm from "../../views/teamMembers/teamMemberEditForm.view"
import Vacations from "../../views/vacations/Vacations.view"
import ClientReport from "../../views/clientReport/ClientReport.view"
import QuickEstimationsV3 from "../../views/estimations/agent/chat/quick-v3/QuickEstimationsV3"
import { VACATION_PERIOD_NAVIGATOR_MODES } from "../../consts/modules/vacations.consts"

export const ADMIN_WITHOUT_REPORT_ROUTES = [
  {
    path: AppRoutes.home.index,
    element: <Home />,
  },
  {
    path: AppRoutes.reporteGeneral.index,
    element: <GeneralReport />,
  },
  {
    path: AppRoutes.reporteGeneral.horasSemana,
    element: <GeneralReport />,
  },
  {
    path: AppRoutes.reporteGeneral.horasProyecto,
    element: <GeneralReport />,
  },
  {
    path: AppRoutes.reporteGeneral.horasEquipo,
    element: <GeneralReport />,
  },
  {
    path: AppRoutes.reporteGeneral.horasCliente,
    element: <GeneralReport />,
  },
  {
    path: AppRoutes.reporteGeneral.horasClienteRedirect,
    element: <GeneralReport />,
  },
  {
    path: AppRoutes.reporteGeneral.consumosEquipo,
    element: <GeneralReport />,
  },
  {
    path: AppRoutes.reporteIndividual.index,
    element: <IndividualReport />,
  },
  {
    path: AppRoutes.reporteIndividual.redirect,
    element: <IndividualReport />,
  },
  {
    path: AppRoutes.clientes.index,
    element: <Clients />,
  },
  {
    path: AppRoutes.clientes.presupuestoCliente,
    element: <ClientBudget />,
  },
  {
    path: AppRoutes.changeLog.index,
    element: <ChangeLog />,
  },
  {
    path: AppRoutes.historialCambios.index,
    element: <TaskChangeLog />,
  },
  {
    path: AppRoutes.historialCambios.redirect,
    element: <TaskChangeLog />,
  },
  {
    path: AppRoutes.dashboard.index,
    element: <Dashboard />,
  },
  {
    path: AppRoutes.reporteOcupacion.index,
    element: <OccupationReport />,
  },
  {
    path: AppRoutes.reporteOcupacion.reporteComparativo,
    element: <OccupationReport />,
  },
  {
    path: AppRoutes.reporteOcupacion.graficas,
    element: <OccupationReport />,
  },
  {
    path: AppRoutes.listaPendientes.index,
    element: <PendingTasks />,
  },
  {
    path: AppRoutes.clientes.detalles,
    element: <Client />,
  },
  {
    path: AppRoutes.clientes.crearProyecto,
    element: <ProjectForm />,
  },
  {
    path: AppRoutes.clientes.editarProyecto,
    element: <ProjectForm />,
  },
  {
    path: AppRoutes.integrantes.index,
    element: <TeamMembers />,
  },
  {
    path: AppRoutes.integrantes.crear,
    element: <TeamMemberCreateForm />,
  },
  {
    path: AppRoutes.integrantes.editar,
    element: <TeamMemberEditForm />,
  },
  {
    path: AppRoutes.vacaciones.gestion,
    element: <Vacations />,
  },
  {
    path: AppRoutes.estimations.agent.chat,
    element: <QuickEstimationsV3 />,
  },
  {
    path: AppRoutes.vacaciones.reporteVacaciones,
    element: <Vacations mode={VACATION_PERIOD_NAVIGATOR_MODES.REPORT} />,
  },
  {
    path: AppRoutes.vacaciones.historialVacaciones,
    element: <Vacations mode={VACATION_PERIOD_NAVIGATOR_MODES.HISTORY} />,
  },
  {
    path: AppRoutes.reporteCliente.index,
    element: <ClientReport />,
  },
  {
    path: AppRoutes.reporteCliente.desarrollo,
    element: <ClientReport />,
  },
  {
    path: AppRoutes.reporteCliente.consumo,
    element: <ClientReport />,
  },
  {
    path: AppRoutes.reporteCliente.burnchart,
    element: <ClientReport />,
  },
  {
    path: AppRoutes.reporteCliente.historicoSprints,
    element: <ClientReport />,
  },
  {
    path: AppRoutes.reporteCliente.tareas,
    element: <ClientReport />,
  },
  {
    path: AppRoutes.reporteCliente.descargaReporte,
    element: <ClientReport />,
  },
]
